<template>
  <div :class="$style.container">
    <div
      :class="$style.header"
      v-if="!$route.path.includes('classroomStudent')"
    >
      <div
        v-if="canNavigateBack"
        :class="$style.backButton"
        @click="navigateBack"
      >
        <img
          :class="$style.backIcon"
          alt=""
          src="/static/img/LeftChevron.svg"
        />
      </div>
      <b :class="$style.title">{{ curriculum.name }}</b>
    </div>

    <!-- <CourseTotals />
    <CourseResources /> -->
    <CourseStages
      @on-update="handleStageUpdate"
      :stages="stages"
      :curriculumId="Number($route.query.curriculumId)"
    />
  </div>
</template>
<script>
// import CourseTotals from './components/CourseTotals.vue'
// import CourseResources from './components/CourseResources.vue'
import CourseStages from "./components/CourseStages.vue";
import CurriculumsAPIService from "@/servicehandlers/CurriculmsAPIService.js";

const curriculumAPI = new CurriculumsAPIService();

export default {
  props: {
    canNavigateBack: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    // CourseTotals,
    // CourseResources,
    CourseStages,
  },
  data() {
    return {
      isAdminAddResourcePopUpOpen: false,
      stages: [],
      curriculum: {},
    };
  },
  methods: {
    async handleStageUpdate() {
      await this.getAllStagesByCurriculumID(this.$route.query.curriculumId);
    },
    async getCurriculum(id) {
      const curriculum = await curriculumAPI.getCurriculumById(id);
      this.curriculum = curriculum;
    },
    async getAllStagesByCurriculumID(id) {
      const stages = await curriculumAPI.getStagesForCurriculum(id);
      this.stages = stages;
    },
    navigateBack() {
      this.$router.go(-1);
    },
    goToCreateAssignment(type) {
      this.$router.push({
        name: "Create Assignment",
        params: { type },
      });
    },
    goToViewAssignment(assignmentId) {
      this.$router.push({
        name: "Take Assignment",
        params: { assignmentId },
      });
    },
    goToEditLesson(assignmentId) {
      this.$router.push({
        name: "Edit Lesson",
        params: { assignmentId },
      });
    },
    handleIconClick(icon, type) {
      if (type === "curriculum") {
        this.goToEditLesson(icon.assignmentId);
      } else if (icon.isPlus) {
        this.goToCreateAssignment(type);
      } else {
        this.goToViewAssignment(icon.assignmentId);
      }
    },
    createNewLesson() {
      this.$router.push({
        name: "Create Lesson",
      });
    },
  },
  mounted() {
    const curriculumId = this.$route.query.curriculumId;
    this.getCurriculum(curriculumId);
    this.getAllStagesByCurriculumID(curriculumId);
  },
};
</script>
<style module scoped>
.backIcon {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: contain;
  cursor: pointer;
}

.backButton {
  margin: 0 !important;
  position: absolute;
  top: 2px;
  left: 0;
  background-color: #f6f6f6;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 5px 10px;
  z-index: 0;
}

.title {
  width: 268px;
  position: absolute;
  margin: 0 !important;
  top: 0;
  left: 50px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  z-index: 1;
}

.header {
  align-self: stretch;
  height: 29px;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  gap: 10px;
  z-index: 6;
}

.stageTitle {
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.expandIcon {
  width: 13.3px;
  position: relative;
  height: 7.7px;
}

.expandIconWrapper {
  width: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stageInfo {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.subHeader {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px 0 0;
}

.container {
  height: 100%;
  flex: 1;
  width: 100%;
  position: relative;
  background-color: #f6f6f6;
  overflow-y: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 50px;
  text-align: left;
  font-size: 25px;
  color: #404040;
  font-family: Helvetica, Arial, sans-serif;
}
</style>
